// src/components/ExamSummaryScreen.jsx
// First screen shown in the exam window - untimed. The clock only starts
// once the student clicks Next here.

import React from 'react';
import { ChevronRight, Clock } from 'lucide-react';
import { toDisplayHtml } from '../utils/richTextDisplay';

const ExamSummaryScreen = ({ homeworkName, summary, unlimitedTime, onNext }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ background: '#1a2332', color: 'white', padding: '16px 24px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '1px', color: '#8b96a8', fontWeight: '700' }}>
          EXAM SIMULATION
        </div>
        <div style={{ fontSize: '17px', fontWeight: '700' }}>{homeworkName}</div>
      </div>

      <div style={{ flex: 1, padding: '40px', maxWidth: '760px', margin: '0 auto', width: '100%' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '20px',
          padding: '10px 16px',
          background: unlimitedTime ? '#eef2ff' : '#fff3cd',
          border: `1px solid ${unlimitedTime ? '#c7d2fe' : '#ffc107'}`,
          borderRadius: '8px',
          color: unlimitedTime ? '#4338ca' : '#856404',
          fontSize: '13px',
          fontWeight: unlimitedTime ? '400' : '600'
        }}>
          <Clock size={15} />
          {unlimitedTime
            ? "This task has no time limit - take as long as you need. This summary page itself isn't timed."
            : "This task is timed. This summary page isn't timed, but once you click Next your timer starts running and can't be paused - make sure you're ready before continuing."}
        </div>

        <h2 style={{ color: '#2c3e50' }}>Task Summary</h2>
        {summary && summary.trim() ? (
          <div
            style={{
              background: 'white',
              border: '2px solid #e2e8f0',
              borderRadius: '8px',
              padding: '20px',
              fontSize: '14px',
              lineHeight: 1.6,
              color: '#2c3e50',
              minHeight: '160px'
            }}
            dangerouslySetInnerHTML={{ __html: toDisplayHtml(summary) }}
          />
        ) : (
          <div style={{
            background: 'white',
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            padding: '20px',
            fontSize: '14px',
            lineHeight: 1.6,
            color: '#2c3e50',
            minHeight: '160px'
          }}>
            No summary has been provided for this task.
          </div>
        )}
      </div>

      <div style={{ padding: '20px 40px', display: 'flex', justifyContent: 'flex-start' }}>
        <button
          type="button"
          onClick={onNext}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: '12px 28px',
            background: '#c33329',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '700',
            fontSize: '15px'
          }}
        >
          Next
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default ExamSummaryScreen;
